import routerOptions0 from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/app/router.options.ts";
import routerOptions1 from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}